<template>
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="'top'">

    <div class="row">
        <div class="col-sm-6" v-for="(item, index) in products" :key="index">
            <div class="card card-custom p-3">
                <div class="card-title">
                    <h5 v-text="item.title" class="mb-0"></h5>
                    <span v-text="item.description"></span>
                </div>
                <div class="card-body p-0" v-html="item.content"></div>
                <div class="card-footer text-center bg-white pb-0">
                    <div class="btn btn-sm outline-btn btn-block" @click="loquiero(item)">¡Lo quiero!</div>
                </div>

            </div>
        </div>
    </div>

</el-form>
</template>

<script>
export default {
    props: {
        corporative: {
            type: Array,
            required: true,
            default: {}
        },
        products: {
            type: Array,
            required: true,
            default: []
        }
    },

    data() {
        return {
            ruleForm: {},
            rules: {}
        }
    },
    methods: {
        loquiero(data) {
           if(this.corporative.actived && this.corporative.opd == null ){
                this.$message.error('Oops, Falta seleccionar el lugar de trabajo');
                return false
            }


            this.$emit("update:number", 1)
            this.$emit("getWizard0", data)
            //alert(data.idproduct)
        }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/camping/wizard0.vue